module.exports = __webpack_public_path__ + "media/public/fonts/QanelasLight/QanelasLight-ad75e4ec974f888a367be675d6d40c89.woff2";